import { StageTrigger } from '@templates/index';
import { useTransportStore } from '@store/index';
import { startRecording, stopRecording } from '@hooks/index';

/**
 * Inline pills next to the BEAT trigger that toggle the three controls
 * the player reaches for the most — without forcing them to open the
 * drawer. Each pill mirrors a store flag and tints when active.
 *
 *   BEAT (264) → CLICK (336) → QUANT (404) → REC (476)
 *
 * Spacing matches the row's existing pill width budget; if the stage
 * is narrower than ~520 px the trailing pills wrap behind the camera
 * frame — fine, they're a power-user surface and the drawer is the
 * accessible-from-anywhere fallback.
 */
export function TransportQuickActions() {
  const metronomeOn = useTransportStore((s) => s.metronomeOn);
  const toggleMetronome = useTransportStore((s) => s.toggleMetronome);
  const quantizeOn = useTransportStore((s) => s.quantizeOn);
  const toggleQuantize = useTransportStore((s) => s.toggleQuantize);
  const recording = useTransportStore((s) => s.recording);

  return (
    <>
      <StageTrigger
        label="CLICK"
        offsetLeft={336}
        onClick={toggleMetronome}
        active={metronomeOn}
        ariaLabel={metronomeOn ? 'Tắt metronome' : 'Bật metronome'}
      />
      <StageTrigger
        label="QUANT"
        offsetLeft={404}
        onClick={toggleQuantize}
        active={quantizeOn}
        ariaLabel={quantizeOn ? 'Tắt quantize' : 'Bật quantize'}
      />
      <StageTrigger
        label={recording ? '■ STOP' : '● REC'}
        offsetLeft={476}
        onClick={() => (recording ? stopRecording() : startRecording())}
        active={recording}
        ariaLabel={recording ? 'Dừng ghi' : 'Bắt đầu ghi'}
      />
    </>
  );
}
